$(function () {
    yieldToWorst = {
        endpoint: '/Main/YieldToWorstBlock/GetYieldToWorstBlockData',
        tableData: {},
        tableHeaderArray: ["Category", "Current", "Month", "Year"],
        tableClassesArray: ["text-left", "", "", "", ""],
        tableTitleArray: [],
        retrieved: false,
        wrapperDiv: $('#veYieldToWorstTable'),
        isExcelDownloading: false,
        toggleEventListenersAdded: false,
        blockId: $('#veYieldToWorstTable').attr("data-blockid"),

        init: async () => {
            commonFundUtils.spinner.show("YieldToWorstDesktopTable");
            yieldToWorst.tableData = await commonFundUtils.getData(yieldToWorst.blockId, yieldToWorst.endpoint)
            yieldToWorst.tableTitleArray = ["Category", yieldToWorst.tableData.CurrentDate, yieldToWorst.tableData.MonthDate, yieldToWorst.tableData.YearDate]
            yieldToWorst.drawTable()
            yieldToWorst.drawMobileTable()
            commonFundUtils.spinner.hide("YieldToWorstDesktopTable");
        },
        //draw the table
        drawTable: async() => {
            await commonFundUtils.drawDesktopTable(
                "veYieldToWorstTable",
                "YieldToWorstDesktopTable",
                yieldToWorst.tableData,
                yieldToWorst.drawHeader,
                yieldToWorst.tableData,
            )
            yieldToWorst.drawBlock(yieldToWorst.tableData.Items)
            yieldToWorst.enableHeaderClicks()
        },
        //used to draw the table header
        drawHeader: (dataSet) => {
            var tableheader;
            tableheader = '<thead>';
            tableheader += '<tr><th></th><th colspan="3" style="border-bottom: 1px solid;">' + dataSet.SecondColumnName + '</th></tr>';
            tableheader += '<tr>';
            $.each(yieldToWorst.tableHeaderArray, function (i) {
                tableheader += `<th id="${this}" class="${yieldToWorst.tableClassesArray[i]} table-header-item${commonFundUtils.getUnderlinedClass("veYieldToWorstTable", this)}"><span class="table-thead d-inline-flex">${yieldToWorst.tableTitleArray[i]} ${commonFundUtils.sortIconMarkup}</span></th>`
            });
            tableheader += '</tr>'
            tableheader += '</thead>';
            return tableheader;
        },
        drawBlock: (dataSet, isExcel) => {
            //console.log(dataSet)
            var tableBlock = '';
            tableBlock += '<tbody>';
            tableBlock += commonFundUtils.drawItemsInGroup(dataSet, yieldToWorst.tableClassesArray, yieldToWorst.tableHeaderArray, true, isExcel)
            tableBlock += '</tbody>';
            if (isExcel) {
                yieldToWorst.isExcelDownloading = false
                return tableBlock
            } else {
                $('#veYieldToWorstTable table').append(tableBlock);
            }
        },
        enableHeaderClicks: () => {
            $('#veYieldToWorstTable .table-header-item').on("click", function () {
                //console.log("click feature initiated");
                commonFundUtils.changeDivAttributes(this, yieldToWorst.wrapperDiv)
                yieldToWorst.tableData.Items = commonFundUtils.sortData(yieldToWorst.tableData.Items, yieldToWorst.wrapperDiv)
                yieldToWorst.drawTable()
            })
            //to run the excel button click event listner only once
            if (yieldToWorst.toggleEventListenersAdded) return
            //activating the "download excel" button click only once
            commonFundUtils.generateExcelTable("veYieldToWorstTable", yieldToWorst.drawExcelTable)
            yieldToWorst.toggleEventListenersAdded = true
        },
        drawMobileTable: () => {
            //var count = 0;
            var mobileTable = '';
            //console.log("mobile table", yieldToWorst.tableData)
            mobileTable += '<div class="d-lg-none">'
                + '<div class="fund-listing-table table-mobile" id="overview">'
            mobileTable += yieldToWorst.drawMobileCardArray(yieldToWorst.tableData.Items, 1, yieldToWorst.tableHeaderArray)
            if ($('#veYieldToWorstTable .table-mobile .table-footer').length == 0 && yieldToWorst.tableData.FooterText !== null) {
                mobileTable += '<div class="table-footer mt-3">' + yieldToWorst.tableData.FooterText + '</div>';
            }
            mobileTable += '</div></div>'
            $(yieldToWorst.wrapperDiv).append(mobileTable);
        },
        drawMobileCardArray: (dataSet, headerColumns, headerArray) => {
            var mobileCard = ''
            $.each(dataSet, function () {
                //console.log(this)
                mobileCard += '<div class="fund-explorer-table__card">';
                mobileCard += commonFundUtils.drawMobileHeader(this, headerColumns, headerArray)
                mobileCard += '<div class="row">'
                mobileCard += '<div class=" fund-explorer-table__card-body col-12"><div class="fund-explorer-table__card-column ">' + yieldToWorst.tableData.SecondColumnName + '</div></div>'
                mobileCard += commonFundUtils.drawMobileItems(this, headerColumns, headerArray.length, headerArray, yieldToWorst.tableTitleArray, true)
                mobileCard += '</div>'
                mobileCard += '</div>'
            })
            return mobileCard;
        },
        drawExcelTable: (wrapperDiv) => {
            var excelTable = '';
            yieldToWorst.isExcelDownloading = true
            $('#excelDrawArea table').remove();
            excelTable += '<table class="d-none excel-table" border="1">';
            excelTable += yieldToWorst.drawHeader(yieldToWorst.tableData)
            excelTable += yieldToWorst.drawBlock(yieldToWorst.tableData.Items, yieldToWorst.isExcelDownloading)
            excelTable += '</table>';
            $('#excelDrawArea').append(excelTable);
            commonFundUtils.downloadExcelReport(wrapperDiv);
        }
    }

    //function is only initiated if the block ID is a number
    if (!isNaN(yieldToWorst.blockId)) {
        yieldToWorst.init()
    }
})